module.exports = __webpack_public_path__ + "static/media/day_eight.08b72a7e.jpg";